<template>
<div class="bg">
    <top-nav title="虚拟背景使用"></top-nav>
  	<div class="cec-info">
		<img src="@/assets/images/cec2022/zoom_title.png"/>
		<img src="@/assets/images/cec2022/use_zoom.png" style="margin-top: 10px;"/>
	</div>
	<img src="@/assets/images/cec2022/bottom_img.png" class="bottom-img"/>
</div>
</template>

<script>
import topNav from "./component/topNav.vue" 
import {ButtonDetail} from '../../config/interface.js'
export default {
    components:{
        topNav
    },
    created(){
        this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
        this.getButtonData();
    },
     methods:{
        //获取按钮信息
        getButtonData(){
            if(this.button_id){
                const url=ButtonDetail;
                let params={
                    button_id:this.button_id
                }
                const method="POST";
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        document.title=res.data.share_title;
                        if(common.is_weixin()){
                            let data=res.data;
                            common.wxShare(data.share_title,data.share_sub_title,data.share_img);
                        }
                    }
                })

            }
        }
    }
}
</script>

<style scoped>
.bg{
    background: white;
    margin-top: 48px;
}
.cec-info{
	padding: 30px 25px;
	position: relative;
}
.cec-info img{
	width: 100%;
}
.cec-info .absolute-img{
	position: absolute;
	top:30px;
	left: 0;
}
.cec-info .red-text{
	color: #B2312E;
}
.cec-info .text{
	margin: 10px 0 30px;
	font-size: 0.28rem;
	line-height: 22px;
}
.cec-info .text .name{
	width: 49%;
	display: inline-block;
}
.cec-info .line1{
	line-height: 40px;
}
.cec-info .line1 img{
	width: 20px;
	vertical-align: middle;
	line-height: 40px;
	margin-right: 10px;
}

.bottom-img{
    width: 100%;
    display: block;
}

</style>


// WEBPACK FOOTER //
// src/pages/cec2022/useZoom.vue